import { useQuery } from '@tanstack/react-query';
import { formsApi } from '../services/forms';
import { FormDefinition } from '../../components/types';

export function useForm(formId: string) {
  const { data: form, isLoading, error } = useQuery({
    queryKey: ['form', formId],
    queryFn: () => formsApi.getForm(formId),
    enabled: !!formId
  });

  return {
    form,
    isLoading,
    error
  };
}
